// Pure registration-validity checks, extracted for cross-stack diffing.
// API mirror: api/src/helpers/registrationValidity.helper.ts.
// Keep these diffable — don't add i18n or side-effects here.

import {slotEndIsBeforeBeginning} from "./slotsUtilities";
import {shouldShowField} from "@sfs/components/FormRenderer/shouldShowField";
import {flattenFieldComponents} from "@sfs/utils/flattenFieldComponents";

export const checkFirstSlot = (registration) => {
  const firstSlot = registration.availabilitySlots?.[0];
  const firstSlotIsDefined = !!(firstSlot?.start && firstSlot?.end);
  const firstSlotEndIsBeforeBeginning = firstSlotIsDefined && slotEndIsBeforeBeginning(firstSlot);

  return {
    firstSlotIsDefined,
    firstSlotEndIsBeforeBeginning,
    isOk: firstSlotIsDefined && !firstSlotEndIsBeforeBeginning,
  };
};

export const checkForm = (registration, project) => {
  const flatFormComponents = flattenFieldComponents(project.formComponents);
  const unfulfilledMandatoryFields = [];
  for (let formComp of flatFormComponents) {
    if (formComp.required) {
      const value = registration.formAnswers?.[formComp.key];

      // Check if the field should be shown before validating
      if (
        shouldShowField(
          formComp.conditional,
          flatFormComponents,
          registration.formAnswers?.[formComp.conditional?.when]
        )
      ) {
        let invalid = false;

        if (
          // No value at all
          value === undefined ||
          value === null ||
          // Checkbox not checked
          value === false ||
          // Empty text
          value === "" ||
          // Empty array
          (Array.isArray(value) && value.length === 0)
        ) {
          invalid = true;
        } else if (Array.isArray(value)) {
          // Checkbox group / Multiselect number of selected elements
          const {min, max} = formComp.selectedCount || {};
          if ((min && value.length < min) || (max && value.length > max)) {
            invalid = true;
          }
        } else if (typeof value === "number") {
          // Validate number input
          const {min, max} = formComp.minMaxNumber || {};
          if ((min && value < min) || (max && value > max)) {
            invalid = true;
          }
        }

        // Add to unfulfilled fields only if the field is invalid and visible
        if (invalid) {
          unfulfilledMandatoryFields.push(formComp.label);
        }
      }
      // If the field is not visible, it's considered valid in any case, even if required
    }
  }

  return {
    unfulfilledMandatoryFields,
    isOk: unfulfilledMandatoryFields.length === 0,
  };
};

export const checkTicketing = (registration, project) => ({
  isOk: !project.ticketingMode || registration?.[`${project.ticketingMode}Tickets`]?.length > 0,
});
